<template>
  <div class="filter-award-month">
    <button
      class="btn w-160px justify-space-between"
      @click="isModalShow = !isModalShow"
    >
      <span>篩選起訖區間</span>
      <v-icon>arrow_drop_down</v-icon>
    </button>
    <div class="filter-award-month__dialog block-3" v-if="isModalShow">
      <!-- 開始 -->
      <div class="d-flex py-5">
        <h5 class="w-84px mr-5">選擇開始年月</h5>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <SimpleSelectWithSearchInput
            class="mr-10px"
            buttonPlaceholder="年"
            buttonWidth="140px"
            modalWidth="140px"
            modalBodyHeight="208px"
            :options="yearOptions"
            :selectedValue.sync="time.yearStartAt"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="月"
            buttonWidth="140px"
            modalWidth="140px"
            modalBodyHeight="208px"
            :options="monthOptions"
            :selectedValue.sync="time.monthStartAt"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 結束 -->
      <div class="d-flex py-5">
        <h5 class="w-84px mr-5">選擇開始年月</h5>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <SimpleSelectWithSearchInput
            class="mr-10px"
            buttonPlaceholder="年"
            buttonWidth="140px"
            modalWidth="140px"
            modalBodyHeight="208px"
            :options="yearOptions"
            :selectedValue.sync="time.yearEndAt"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            buttonPlaceholder="月"
            buttonWidth="140px"
            modalWidth="140px"
            modalBodyHeight="208px"
            :options="monthOptions"
            :selectedValue.sync="time.monthEndAt"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- foot -->
      <div class="text-right">
        <button class="btn mr-10px w-80px px-0" @click="clearHandler">
          清除選取
        </button>
        <button class="btn btn-primary w-80px" @click="applyHandler">
          套用
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
  },
  props: {
    selectedOption: {
      type: Object,
      default() {
        return {
          yearStartAt: '',
          monthStartAt: '',
          yearEndAt: '',
          monthEndAt: '',
        };
      },
    },
  },
  data() {
    return {
      isModalShow: false,
      time: {
        yearStartAt: this.selectedOption.yearStartAt,
        monthStartAt: this.selectedOption.monthStartAt,
        yearEndAt: this.selectedOption.yearEndAt,
        monthEndAt: this.selectedOption.monthEndAt,
      },
    };
  },
  computed: {
    yearOptions() {
      const startYear = 1991;
      const range = new Date().getFullYear() - startYear + 1;
      return [...Array(range).keys()].map((i) => ({
        value: (i + startYear).toString(),
        text: (i + startYear).toString(),
      }));
    },
    monthOptions() {
      return [...Array(12).keys()].map((i) => ({
        value: (i + 1).toString(),
        text: (i + 1).toString(),
      }));
    },
  },
  watch: {
    selectedOption: {
      handler() {
        this.$set(this, 'time', this.selectedOption);
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('notifications', ['error']),
    clearHandler() {
      this.time.yearStartAt = '';
      this.time.monthStartAt = '';
      this.time.yearEndAt = '';
      this.time.monthEndAt = '';
      this.isModalShow = false;
    },
    applyHandler() {
      let hasEmpty = false;
      Object.keys(this.time).forEach((key) => {
        if (this.time[key] === '') {
          hasEmpty = true;
        }
      });
      if (hasEmpty) {
        this.error('請選擇正確日期');
      } else {
        this.$emit('update:selectedOption', { ...this.time });
      }
      this.clearHandler();
    },
  },
};
</script>

<style lang="scss">
.filter-award-month {
  position: relative;

  &__dialog {
    position: absolute;
    margin-top: 4px;
    width: 434px;
    padding: 20px;
    background: white;
    z-index: 1;
  }
}
</style>
